module.exports = __webpack_public_path__ + "media/honey-icons/icon-hallway-42ae5e15.svg";